#!/usr/bin/env node
import fs from 'fs-extra';
import path from 'node:path';
import { Command } from 'commander';
import { type PackageJson } from 'type-fest';

import { init, add } from '@/src/commands';

process.on('SIGINT', () => process.exit(0));
process.on('SIGTERM', () => process.exit(0));

async function main() {
  const packageJsonPath = path.join('package.json');

  const packageInfo = fs.readJSONSync(packageJsonPath) as PackageJson;

  const program = new Command()
    .name('multiverse-ui')
    .description('add components and dependencies to your project')
    .version(
      packageInfo.version || '1.0.0',
      '-v, --version',
      'display the version number'
    );

  program.addCommand(init).addCommand(add);

  program.parse();
}

main();
